import { Lock } from '@material-ui/icons';
import { useCarrierSettings } from 'shared/settings/CarrierSettingsAPI';

export function LoadCreationLockIcon() {
  const { data: settings } = useCarrierSettings();

  if (!settings?.can_create_load) {
    return <Lock color="action" />;
  }

  return null;
}
